import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const CalendarCheckIcon = (props: IconProps) => (
  <Icon width="20px" height="20px" viewBox="0 0 20 20" {...props}>
    <path d="M15.833 3.333H15V1.666h-1.667v1.667H6.667V1.666H5v1.667h-.833c-.917 0-1.667.75-1.667 1.666v11.667c0 .917.75 1.667 1.667 1.667h11.666c.917 0 1.667-.75 1.667-1.667V4.999c0-.916-.75-1.666-1.667-1.666Zm0 13.333H4.167V8.333h11.666v8.333Zm-11.666-10V4.999h11.666v1.667H4.167ZM8.8 15.383l4.942-4.942-.884-.883L8.8 13.616l-1.758-1.758-.884.883L8.8 15.383Z" />
  </Icon>
);

export default memo(CalendarCheckIcon);
